import api from './api';

export const meetingService = {
  getStatus: async () => {
    const response = await api.get('/meeting-imports/status');
    return response.data;
  },

  getAll: async (projectId) => {
    const response = await api.get('/meeting-imports', { params: { projectId } });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/meeting-imports/${id}`);
    return response.data;
  },

  upload: async ({ projectId, file, title, meetingDate }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    formData.append('title', title);
    formData.append('meetingDate', meetingDate);
    const response = await api.post('/meeting-imports', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  retry: async (id) => {
    const response = await api.post(`/meeting-imports/${id}/retry`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/meeting-imports/${id}`);
    return response.data;
  },

  approve: async (id, draftIds) => {
    const response = await api.post(`/meeting-imports/${id}/approve`, { draftIds });
    return response.data;
  },

  updateDraft: async (draftId, data) => {
    const response = await api.put(`/meeting-imports/drafts/${draftId}`, data);
    return response.data;
  },

  discardDraft: async (draftId) => {
    const response = await api.post(`/meeting-imports/drafts/${draftId}/discard`);
    return response.data;
  },

  restoreDraft: async (draftId) => {
    const response = await api.post(`/meeting-imports/drafts/${draftId}/restore`);
    return response.data;
  },
};

export default meetingService;
